import _ from 'underscore';
import Backbone from 'backbone';

import TrackerModel from 'models/tracker';


export default TrackerModel.extend({
  urlRoot: API_PREFIX + window.Urls['tracker_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'page',
  })
});



// WEBPACK FOOTER //
// ./static/js/models/page.js